var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#34AADF",
  d: "M11 21.8c5.965 0 10.8-4.835 10.8-10.8S16.965.2 11 .2.2 5.035.2 11 5.035 21.8 11 21.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.694 10.907s5.4-2.216 7.273-2.996C12.685 7.598 15.12 6.6 15.12 6.6s1.124-.437 1.03.624c-.031.437-.281 1.966-.53 3.62-.375 2.342-.781 4.901-.781 4.901s-.063.718-.593.843-1.405-.437-1.56-.562c-.126-.093-2.342-1.498-3.154-2.185-.218-.187-.468-.562.032-.999a119 119 0 0 0 3.277-3.121c.375-.375.75-1.249-.811-.187-2.217 1.53-4.402 2.965-4.402 2.965s-.499.312-1.435.031c-.937-.28-2.03-.655-2.03-.655s-.748-.468.531-.968"
})));
export default SvgTelegram;